export default "__VITE_ASSET__D84TgK1d__"